import { RouterProvider } from 'react-router-dom';
import { appRouter } from './routes/app.route';

function App() {
    return <RouterProvider router={appRouter} />;
}

export default App;
